import { api } from "./api";

// Cadastro dos candidatos do portal, pela área administrativa.
// Não confundir com usuarioService, que trata os usuários internos (equipe).

export const listarCandidatos = (termo = "") =>
  api.get(`/candidato-admin/listar${termo ? `?termo=${encodeURIComponent(termo)}` : ""}`);

export const obterCandidato = (id) => api.get(`/candidato-admin/${id}`);

export const salvarCandidato = (dto) => api.post("/candidato-admin/salvar", dto);

export const redefinirSenhaCandidato = (id, senha) =>
  api.post(`/candidato-admin/${id}/redefinir-senha`, { Senha: senha });
